import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Footer from '../components/Footer';
import vercelAnalytics from '../services/vercelAnalyticsService';
import { useBasicPerformanceTracking } from '../hooks/usePerformanceMonitoring';

function HomeNew() {
  const navigate = useNavigate();

  // Performance monitoring for landing page
  useBasicPerformanceTracking('landing_page');

  // Track landing page view
  useEffect(() => {
    vercelAnalytics.trackLandingPageView('direct');
  }, []);

  return (
    <div className="min-h-screen">
      <header className="border-b bg-white/50 backdrop-blur-sm sticky top-0 z-10">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="text-xl font-bold text-primary">Casal Resolve</h1>
          <div className="flex gap-2">
            <Button variant="ghost" onClick={() => {
              vercelAnalytics.trackConversionFunnelStep('main', 1, { action: 'login_click', source: 'header' });
              navigate("/login");
            }}>
              Entrar
            </Button>
            <Button onClick={() => {
              vercelAnalytics.trackConversionFunnelStep('main', 1, { action: 'register_click', source: 'header' });
              navigate("/register");
            }}>
              Começar Grátis
            </Button>
          </div>
        </div>
      </header>
      
      <Hero />
      <Features />
      
      <section className="py-20 px-4 bg-gradient-soft">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-bold mb-6">
            Pronto para fortalecer seu relacionamento?
          </h2>
          <p className="text-xl text-muted-foreground mb-8">
            Junte-se a milhares de casais que já transformaram seus relacionamentos
          </p>
          <Button 
            variant="hero" 
            size="xl" 
            onClick={() => navigate("/register")}
          >
            Comece Agora - É Grátis
          </Button>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default HomeNew;